import Particles, { initParticlesEngine } from "@tsparticles/react";
import { useEffect, useMemo, useState } from "react";
import styles from "../../css/globals.module.css";
// import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.

const ParticlesComponent = (props) => {
    const [init, setInit] = useState(false);
    const [isDayMode, setIsDayMode] = useState(false); // Define the isDayMode variable

    useEffect(() => {
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      }).then(() => {
        setInit(true);
      });
    }, []);
  
    const particlesLoaded = (container) => {
      console.log(container);
    };

    useEffect(() => {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      setIsDayMode(!mediaQuery.matches);
      const handler = (e) => setIsDayMode(!e.matches);
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
    }, []);
    
    const options = useMemo(
      () => ({
        background: {
          color: {
              value: isDayMode ? "#ffffff" : "#000000", 
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "repulse",
            },
            onHover: {
              enable: true,
              mode: 'repulse',
            },
          },
          modes: {
            push: {
              distance: 200,
              duration: 15,
            },
            repulse: {
              distance: 70,
              duration: 15,
            },
            grab: {
              distance: 150,
            },
          },
        },
        particles: {
          color: {   value: isDayMode ? "#000000" : "#ffffff",  },
          move: {
            direction: "none",
            enable: true,
            outModes: "out",
            random: true,
            speed: 0.3
          },
          number: {
            density: {
              enable: true
            },
            value: 600
          },
          opacity: {
            animation: {
              enable: true,
              speed: 5
            },
            value: { min: 0.3, max: 0.6 }
          },
          shape: {
            type: "circle"
          },
          size: {
            value: 1
          }
        },
        detectRetina: true,
      }),
      [isDayMode],
    );

  return <Particles id={props.id} init={particlesLoaded} options={options} />; 
};

export default ParticlesComponent;
